<p-toast></p-toast>
<div class="m-3 md:mx-5 bg-white border-round">
    <div class="p-3 md:px-6">
        <h2>{{'reset_password'| translate}}</h2>
        <form  [formGroup]="authForm" (ngSubmit)="submitPasswordForm()" *ngIf="!passwordResetted">
            <div class="formgrid grid p-fluid">
                <div class="field col-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-lock"></i></span>
                        <input type="password"
                               formControlName="newPassword"
                               id="newPassword"
                               autocomplete="new-password"
                               pInputText placeholder="{{'new_password' | translate}}">
                    </div>
                    <small class="p-error block" *ngIf="isSubmitting && f?.newPassword?.errors?.required != undefined">{{'password_required' | translate}}</small>
                </div>
                <div class="field col-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-lock"></i></span>
                        <input type="password"
                               formControlName="newPasswordConfirm"
                               id="newPasswordConfirm"
                               autocomplete="new-password"
                               pInputText placeholder="{{'verify_new_password' | translate}}">
                    </div>
                    <small class="p-error block" *ngIf="isSubmitting && f?.newPasswordConfirm?.errors?.required != undefined">{{'password_required' | translate}}</small>
                    <small class="p-error block" *ngIf="isSubmitting && f?.newPasswordConfirm?.errors?.mustMatch != undefined">{{'password_not_match' | translate}}</small>
                </div>
            </div>
            <button pButton label="{{'change_password' | translate}}"
                    type="submit"
                    class="p-button-dlnd p-button-raised col-12 md:col-4 md:col-offset-8"></button>
        </form>
        <div *ngIf="passwordResetted">{{'password_reset_ok_login'|translate}}</div>
    </div>
</div>

